import { render, staticRenderFns } from "./CompanionPostAssessmentModal.vue?vue&type=template&id=7990f9fc&scoped=true&lang=pug&"
import script from "./CompanionPostAssessmentModal.vue?vue&type=script&lang=js&"
export * from "./CompanionPostAssessmentModal.vue?vue&type=script&lang=js&"
import style0 from "./CompanionPostAssessmentModal.vue?vue&type=style&index=0&id=7990f9fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7990f9fc",
  null
  
)

export default component.exports